import { useEffect, useState } from "react"

import Config from "../Config"

const useAsyncSelect = ({
   dataKey = "data",
   totalKey = "total",
   applyOptionsFilter = false,
   keyToCheck = "",
   valueToMatch = "",
   customExecutionHandlers = null,
   labelKey = "",
   valueKey = "",
   defaultPage = 1,
   params = {},
   restrictExecutionOnRender = false,
   apiFunc = () => {},
   onOptionSelect = () => {},
   deps = [],
   attachSignal = true,
   modifyLabel = false,
   handleLabelModification = () => {},
   enabled = true,
   shouldAppend = true,
}) => {
   let controller = new AbortController()
   let signal = controller.signal
   const [isRefetch, setIsRefetch] = useState(false)
   const [selectedOption, setSelectedOption] = useState(null)
   const [selectEntity, setSelectEntity] = useState({
      data: [],
      fetching: false,
      page: defaultPage,
      Q: "",
      isDataAvailable: false,
   })

   useEffect(() => {
      if (!enabled) return
      if (!restrictExecutionOnRender) {
         handleGetSelectEntityData(selectEntity.page)
      }
      if (typeof customExecutionHandlers === "function") {
         customExecutionHandlers()
      }
      return () => {
         controller.abort()
      }
   }, [...deps, isRefetch, selectEntity.Q, enabled])

   const handleSearchOnOptions = value => {
      if (!value && selectEntity.Q < 1) return

      setSelectEntity(prev => {
         return {
            ...prev,
            data: [],
            page: 1,
            Q: value,
         }
      })
   }

   const handleSelectAOption = (option = "", id) => {
      setSelectedOption(option)
      onOptionSelect(option, id)
   }

   const handleGetSelectEntityData = page => {
      if (!enabled) return
      setSelectEntity(prev => ({ ...prev, fetching: true }))
      apiFunc(
         {
            limit: Config.LIMIT,
            page: page,
            ...(selectEntity.Q && { Q: selectEntity.Q }),
            ...(params && params),
         },
         attachSignal && signal
      )
         .then(res => {
            setSelectEntity(prev => ({
               ...prev,
               fetching: false,
               page: page + 1,
               isDataAvailable: res?.[dataKey].length == Config.LIMIT,
               data: (() => {
                  let options = res?.[dataKey].map(item => ({
                     ...item,
                     value: item[valueKey],
                     label: item[labelKey],
                  }))

                  if (applyOptionsFilter) {
                     options = options.filter(
                        item => item[keyToCheck] != valueToMatch
                     )
                  }
                  if (modifyLabel) {
                     options = handleLabelModification(options)
                  }

                  return shouldAppend ? [...prev.data, ...options] : options
               })(),
            }))
         })
         .finally(() => {
            setSelectEntity(prev => ({
               ...prev,
               fetching: false,
            }))
         })
   }

   return {
      isRefetch,
      selectEntity,
      selectedOption,
      setIsRefetch,
      setSelectEntity,
      handleGetSelectEntityData,
      handleSearchOnOptions,
      handleSelectAOption,
      setSelectedOption,
   }
}

export default useAsyncSelect
